/**
 * 嵌入式聊天与百度统计注入。
 */
export function inertScript() {
  const NODE_ENV = process.env.NODE_ENV;
  const excludePath = ["/chatBotInsertion", "/chatBotInsertError"]; // 聊天嵌入页不展示浮窗，需单独注入百度统计。

  const currentPath = window.location.pathname;
  const globalBdScript = !excludePath.includes(currentPath);
  const checkCurrentLocation = () => {
    // 根据 URL 判断是否显示 iframe
    const tipElement = document.getElementById("tip_joinmchat_www");
    const iframeElement = document.getElementById("inframe_container");

    if (globalBdScript) {
      if (tipElement) tipElement.style.display = "block";
      if (iframeElement && iframeElement.style.display === "block") iframeElement.style.display = "block";
    } else {
      if (tipElement) tipElement.style.display = "none";
      if (iframeElement) iframeElement.style.display = "none";
    }
  };
  window.addEventListener("popstate", function (event) {
    checkCurrentLocation();
  });
  const mods = ["production"];

  if (mods.includes(NODE_ENV)) {
    if (globalBdScript) {
      // 嵌入式聊天的全局配置名属于已发布脚本契约，品牌迁移时保持兼容。
      // 当前项目只使用 JoinCompass 的聊天配置，不再按访问域名切换页面与客服标识。
      window.JoinMChatBotConfig = {
        baseURL: "https://gc.pandarocket.cn/",
        wwwBaseURL: "https://joinmc.cn",
        pageId: "4768cafdaa104c75b1fd33fc3cf30f04",
        csId: "095925da99ff4e0d83bc696279054077",
      };

      let st = document.createElement("script");
      st.type = "module";
      st.async = true;
      st.src = "https://joinmc.cn/iframe.js";
      let header = document.getElementsByTagName("head")[0];
      header.appendChild(st);

      var _hmt = _hmt || [];
      (function () {
        let hm = document.createElement("script");
        // hm.src = "https://hm.baidu.com/hm.js?ad9d540f2174b878cf0451bfb8a60d41";
        hm.src = "https://hm.baidu.com/hm.js?d0d23e67fc83bb251ade89d690021e8c";

        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }
  }
}
